import { render, staticRenderFns } from "./OverlaySpinner.vue?vue&type=template&id=218ca70d&"
import script from "./OverlaySpinner.vue?vue&type=script&lang=js&"
export * from "./OverlaySpinner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports